module.exports = __webpack_public_path__ + "static/media/bkg_3.29864428.jpg";